import { Helmet } from 'react-helmet-async';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const ModuleHelpPage = () => {
    return (
        <>
            <Helmet>
                <meta
                    content='noindex, nofollow'
                    name='robots'/>

                <title>Module Help</title>
            </Helmet>

            <main
                className='flex'
                id='main-content'
                style={{ minHeight: '100dvh' }}>
                <h1 className='sr-only'>
                    Module Help
                </h1>

                <div className='m-auto'>
                    <div className='layout-container pt-30 sm:pt-0 md:pt-20'>
                        <h2 className='type-style-2'>
                            Animated Text Formatting
                        </h2>

                        <p className='mt-20'>Use Contentful rich text formatting marks to control how text is rendered:</p>

                        <ul className='list-disc flex flex-col gap-20 mt-20 pl-20'>
                            <li><strong>Bold</strong> — renders as black-highlighted text</li>
                            <li><em>Italic</em> — renders as animated scroll text; separate items with <code>,</code> (e.g. <em>skiers, hikers, cyclists</em>)</li>
                            <li>Hyperlink — renders as orange-highlighted linked text with an animated chevron icon</li>
                            <li>Plain text — rendered as-is (emojis below are replaced with icons)</li>
                        </ul>

                        <h2 className='type-style-2 mt-40'>
                            Available Icons
                        </h2>

                        <p className='mt-20'>Use these characters in the rich text field — they are mapped to SVG icons:</p>

                        <ul className='list-disc flex flex-col gap-20 mt-20 pl-20'>
                            <li><code>{'>'}</code></li>
                            <li><code>🚲</code></li>
                            <li><code>🥾</code></li>
                            <li><code>🏁</code></li>
                            <li><code>❤️</code></li>
                            <li><code>👟</code></li>
                            <li><code>👍</code></li>
                            <li><code>🏆</code></li>
                            <li><code>🌊</code></li>
                        </ul>
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ModuleHelpPage;
